import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router';
import { AuthorizationObjectPermissions, AuthorizationObjectType, Business_Profile_Enum } from '@kheops/graphql';
import { currentContextAtom, globalAuthorizationAtom, userAtom } from '../state';
import { RoutePaths, RoutePathType } from './AppRoutes';

export interface AuthorizedRouteProps {
  permission: AuthorizationObjectPermissions;
  object: AuthorizationObjectType;
  redirectUri?: RoutePathType;
  realm?: Business_Profile_Enum;
}

export default function AuthorizedRoute({ permission, object, redirectUri = RoutePaths.ROOT, realm }: AuthorizedRouteProps): React.JSX.Element {
  const globalAuthorization = useAtomValue(globalAuthorizationAtom);
  const { isStaff } = useAtomValue(userAtom);
  const { realm: currentRealm } = useAtomValue(currentContextAtom);

  const isAuthorized = useMemo(() => {
    return globalAuthorization.some((authorization) => authorization.permission === permission && authorization.object === object);
  }, [globalAuthorization]);

  if ((!isAuthorized && !isStaff) || (realm && currentRealm !== realm)) {
    return <Navigate to={redirectUri} replace />;
  }

  return (
    <Outlet />
  );
}
